//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

type LoadingBarProps = LinearProgressProps & {
  loading: boolean;
};

const LoadingBar = ({ loading = false, ...props }: LoadingBarProps) => (loading ? <StyledLinearProgress color="primary" {...props} /> : null);

export default LoadingBar;

const StyledLinearProgress = styled(LinearProgress)`
  position: fixed;
  width: 100%;
  top: 0;
  height: 2px;
  background: none;
  z-index: 9999;

  & .MuiLinearProgress-bar {
    ${({ theme }) => convertStylesToStyled(theme.customOverrides?.LoadingBar)}
  }
`;
